import React from 'react';

import Hero from '../components/Hero';
import Headers from '../components/Header';

import About from '../components/About';
import Portfolio from '../components/Portfolio';
import Skills from '../components/Skills';

import Contact from '../components/Contact';
import Footer from '../components/Footer';
import BackTopBtn from '../components/BackTopBtn';
import { Outlet } from 'react-router-dom';

const Home = () => {
    return (
        <div>
            <div className='bg-white relative'>
                <Headers />
                <Outlet></Outlet>
                <Footer />
                <BackTopBtn />
            </div>
        </div>
    );
};

export default Home;